import React, { useEffect, useState, useRef} from 'react';
import './Filter.css';
import '../../common/CommonText.css';

const Filter = ({ onFilterSelect, defaultValue = '' }) => {

  const filterOptions = [
    { value: 'All', label: 'All' },
    { value: 'Archived', label: 'Archived' },
    { value: 'Unarchived', label: 'Active' }
  ];
  
  const [selectedOption, setSelectedOption] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleOptionClick = (option) => {
    setSelectedOption(option.value);
    setIsOpen(false);
    onFilterSelect(option.value); 
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    setSelectedOption(defaultValue);
  }, [defaultValue]);
  return (


  <div className='filter-container' ref={dropdownRef}>
    <div className='filter-text-container'>
      <div>
        <svg className='filter-svg' width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.74976 7.99891V15.0024C8.78475 15.269 8.69726 15.5534 8.49604 15.7401C8.4151 15.8225 8.31896 15.8878 8.21313 15.9324C8.10729 15.977 7.99383 16 7.87925 16C7.76467 16 7.65121 15.977 7.54538 15.9324C7.43954 15.8878 7.3434 15.8225 7.26246 15.7401L5.50396 13.9537C5.40859 13.8589 5.33608 13.743 5.29207 13.615C5.24806 13.487 5.23374 13.3505 5.25024 13.216V7.99891H5.224L0.184694 1.4398C0.0426205 1.25452 -0.0214858 1.01965 0.00638272 0.786498C0.0342512 0.553349 0.151829 0.340884 0.333423 0.195529C0.49965 0.0711015 0.683375 0 0.875848 0H13.1242C13.3166 0 13.5003 0.0711015 13.6666 0.195529C13.8482 0.340884 13.9657 0.553349 13.9936 0.786498C14.0215 1.01965 13.9574 1.25452 13.8153 1.4398L8.776 7.99891H8.74976Z" fill="#565656"/>
        </svg>
      </div>
      <label className='common-text fts-15 ftw-4 dk-gray'>Filter By</label>
    </div>

    <div className="custom-dropdown" onClick={() => setIsOpen(!isOpen)}>
      <div className="selected-option fts-13 lt-gray">
        {filterOptions.find(opt => opt.value === selectedOption)?.label || selectedOption}
        <span className={`filter-dropdown-icon fts-12 ${isOpen ? 'open' : ''}`}>▼</span>
      </div>
      {isOpen && (
        <ul className="options-list">
          {filterOptions.map((option, index) => (
            <li
              key={index}
              className={`option-item dk-gray fts-13 ${selectedOption === option.value ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              <span className="check-icon fts-13">{selectedOption === option.value ? '✔' : ''}</span>
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>
);
};

export default Filter;